import tw from "twin.macro";

export const tabCss = tw`inline-flex items-center transition-colors cursor-pointer`;
